import { MarkdownNodeType } from '../../common';
import Markdown from '../../markdown';

const allowList = [MarkdownNodeType.STRONG];

export interface InlineMarkdownProps {
  children?: string;
  className?: string;
}

export default function InlineMarkdown(props: InlineMarkdownProps) {
  return <Markdown {...props} as="span" allowList={allowList} blockList={undefined} />;
}
